import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
export const SearchBarWrapper = (props)=>{
    return /*#__PURE__*/ _jsx("section", {
        className: "search-bar container--lg align--center",
        children: /*#__PURE__*/ _jsx("div", {
            className: "search-bar__wrapper",
            children: props.children
        })
    });
};
{}